import { ChangeEvent, FormEvent, useState } from "react";
import CustomLabel from "../../common/CustomLabel";
import { isValidEmail } from "../../../utils/authHelpers";
import devLogger from "../../../utils/devLogger";

const ProfileEdit = () => {
  const [errors, setErrors] = useState<{
    fullName?: string;
    phoneNumber?: string;
    email?: string;
  }>({
    fullName: undefined,
    phoneNumber: undefined,
    email: undefined,
  });

  const [profileData, setProfileData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
  });

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "fullName") {
      setErrors((prev) => ({
        ...prev,
        fullName:
          !value || value.length < 2
            ? "Full name should be at least 2 characters"
            : undefined,
      }));
    } else if (name === "phoneNumber") {
      setErrors((prev) => ({
        ...prev,
        phoneNumber:
          !value || !/^[\d+\-()]+$/.test(value)
            ? "Invalid phone number format"
            : undefined,
      }));
    } else if (name === "email") {
      setErrors((prev) => ({
        ...prev,
        email:
          value && !isValidEmail(value) ? "Invalid email format" : undefined,
      }));
    }

    setProfileData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    devLogger.log(profileData);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-[calc(100%-32px)] mx-auto pt-6"
    >
      <CustomLabel
        labelText="Full Name"
        labelTextClass="px-0 mb-2 text-sm font-bold"
        labelWrapClass="!gap-1 mb-4"
      >
        <input
          type="text"
          name="fullName"
          value={profileData.fullName}
          onChange={handleInputChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-7 leading-tight focus:outline-none focus:shadow-outline"
        />
        {errors.fullName && (
          <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
            {errors.fullName}
          </p>
        )}
      </CustomLabel>

      <CustomLabel
        labelText="Phone Number"
        labelTextClass="px-0 mb-2 text-sm font-bold"
        labelWrapClass="!gap-1 mb-4"
      >
        <input
          type="text"
          name="phoneNumber"
          value={profileData.phoneNumber}
          onChange={handleInputChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-7 leading-tight focus:outline-none focus:shadow-outline"
        />
        {errors.phoneNumber && (
          <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
            {errors.phoneNumber}
          </p>
        )}
      </CustomLabel>

      <CustomLabel
        labelText="E-mail Address"
        labelTextClass="px-0 mb-2 text-sm font-bold"
        labelWrapClass="!gap-1"
      >
        <input
          type="email"
          name="email"
          value={profileData.email}
          onChange={handleInputChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-7 leading-tight focus:outline-none focus:shadow-outline"
        />
        {errors.email && (
          <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
            {errors.email}
          </p>
        )}
      </CustomLabel>

      <button
        type="submit"
        className="w-full mt-[52px] bg-black hover:bg-gray-7 text-white font-bold py-2 px-4 rounded-[10px] focus:outline-none focus:shadow-outline"
      >
        Save
      </button>
    </form>
  );
};

export default ProfileEdit;
